// Settings page — carrier info, role, ELD connection, about

import { showToast } from '../app.js';

export function renderSettings(container, ctx) {
  container.innerHTML = `
    <div class="page">
      <div class="page-title">Settings</div>

      <div class="card">
        <div class="card-title">Profile</div>
        <div class="card-row"><span>Name</span><span>${ctx.userName || 'Not set'}</span></div>
        <div class="card-row"><span>Role</span><span>${{'owner-operator': 'Owner Operator', carrier: 'Carrier', driver: 'Driver', mechanic: 'Mechanic', broker: 'Broker'}[ctx.role] || ctx.role}</span></div>
        <div class="card-row"><span>Carrier DOT#</span><span>${ctx.carrierDOT || 'Not set'}</span></div>
        <button class="btn btn-secondary btn-small" onclick="window._switchRole()" style="margin-top: 8px;">Switch Role</button>
      </div>

      <div class="card">
        <div class="card-title">ELD Connection</div>
        <p style="color: var(--text-dim); font-size: 0.85em; margin-bottom: 12px;">
          Connect your ELD to enable automatic HOS compliance verification.
          Your carrier admin authorizes access via OAuth.
        </p>
        <button class="btn btn-secondary" onclick="showToast('ELD OAuth integration coming soon — Motive + Samsara')">
          Connect ELD (Motive / Samsara)
        </button>
      </div>

      <div class="card">
        <div class="card-title">Carrier Vetting</div>
        <p style="color: var(--text-dim); font-size: 0.85em; margin-bottom: 12px;">
          View your carrier's FMCSA profile and compliance score on freight.rootz.global.
        </p>
        ${ctx.carrierDOT
          ? `<a href="https://freight.rootz.global/carrier/${ctx.carrierDOT}" target="_blank" class="btn btn-secondary">View Carrier Profile →</a>`
          : '<p style="color: var(--fail); font-size: 0.85em;">Set your DOT number above to view your profile.</p>'
        }
      </div>

      <div class="card">
        <div class="card-title">Data</div>
        <button class="btn btn-secondary btn-small" onclick="window._exportData()" style="margin-bottom: 8px;">Export All Data (JSON)</button>
        <button class="btn btn-danger btn-small" onclick="window._resetApp()">Reset App</button>
      </div>

      <div class="card">
        <div class="card-title">About</div>
        <div class="card-row"><span>Version</span><span>${ctx.appVersion}</span></div>
        <div class="card-row"><span>Platform</span><span>FreightProof PWA</span></div>
        <div class="card-row"><span>API</span><span>freight.rootz.global</span></div>
        <div class="card-row"><span>Legal Basis</span><span style="font-size: 0.8em;">Montgomery v. Caribe Transport II (2026)</span></div>
        <p style="color: var(--text-dim); font-size: 0.8em; margin-top: 8px;">
          Zero Trust for Freight. Every actor proves themselves. Every transaction has a receipt. Nothing is assumed.
        </p>
      </div>
    </div>
  `;

  window._switchRole = () => {
    if (confirm('Switch to a different role? Your data will be kept.')) {
      localStorage.removeItem('fp_role');
      location.reload();
    }
  };

  window._resetApp = () => {
    if (confirm('This will clear all local data. Are you sure?')) {
      localStorage.clear();
      indexedDB.deleteDatabase('freightproof');
      location.reload();
    }
  };

  window._exportData = async () => {
    showToast('Export coming soon');
  };
}
